import { render, staticRenderFns } from "./region.vue?vue&type=template&id=02ef51f8&"
import script from "./region.vue?vue&type=script&lang=js&"
export * from "./region.vue?vue&type=script&lang=js&"
import style0 from "./region.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02ef51f8')) {
      api.createRecord('02ef51f8', component.options)
    } else {
      api.reload('02ef51f8', component.options)
    }
    module.hot.accept("./region.vue?vue&type=template&id=02ef51f8&", function () {
      api.rerender('02ef51f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/region.vue"
export default component.exports